import { constructParams } from "./utils";

const apiUrl = "https://360-api.socif.co";
// const apiUrl = "http://localhost:7071";
/*
 * Home & Eta
 */
const localUrl = "http://localhost:7074"

export const getRouteInfo = async (routeId) => {
  const result = await fetch(`${apiUrl}/api/route/${routeId}`).then((res) =>
    res.json()
  );
  return result ? result.data[0] : null;
};

export const getRouteStops = async (routeId, routeSeq) => {
  const result = await fetch(
    `${apiUrl}/api/route-stop/${routeId}/${routeSeq}`
  ).then((res) => res.json());
  return result ? result.data : null;
};

export const getStop = async (stopId) => {
  const result = await fetch(`${apiUrl}/api/stop/${stopId}`).then((res) =>
    res.json()
  );
  return result ? result.data : null;
};

export const getRouteStopEta = async (routeId, routeSeq) => {
  const result = await fetch(
    `${apiUrl}/api/eta/route-stop/${routeId}/${routeSeq}`
  ).then((res) => res.json());
  return result ? result.data : null;
};

export const getRouteStopEtaByStop = async (routeId, routeSeq, stopSeq) => {
  const result = await fetch(
    `${apiUrl}/api/eta/route-stop/${routeId}/${routeSeq}/${stopSeq}`
  ).then((res) => res.json());
  return result ? result.data : null;
};

export const getRouteTraffic = async (routeId, routeSeq) => {
  const result = await fetch(
    `${apiUrl}/api/route-speedmap/${routeId}/${routeSeq}`
  ).then((res) => res.json());
  return result ? result.data : null;
};

/*
 * Schedule
 */

export const getRouteSchedule = async (routeId, weekday) => {
  const result = await fetch(
    `${apiUrl}/api/weekdaySchedule/${routeId}/${weekday}`
  ).then((res) => res.json());
  return result ? result.data : null;
};

/*
 * Setting
 */

export const getSetting = async (court, site) => {
  const result = await fetch(`${apiUrl}/api/setting/${court}/${site}`).then(
    (res) => res.json()
  );
  return result ? result.data : null;
};


// export const getColor = async (operatorId) => {
//   const result = await fetch(
//     `${localUrl}/api/eta-app-setting/${operatorId}`
//   ).then((res) => res.json());
//   return result ? result.data : null;
// };


/*
 * Route Network
 */

export const getRouteNetwork = async (routeName, routeSeq) => {
  const result = await fetch(
    `${apiUrl}/api/route-network/${routeName}/${routeSeq}`
  ).then((res) => res.json());
  return result ? result.data : null;
};

